module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/requisition-reward-50.eb96f8a3.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/requisition-reward-50.png
// module id = 3797
// module chunks = 11